import { StringUtils, engineComponent } from "neo-common";
import { Style } from "./Style";
import { ComponentTypes } from "../../ComponentTypes";
import { CustomUtils } from "../../../Utils/CustomUtils";

/**
 * The animation style is used for defined behaviour animation from sprite sheet.
 * Example:
 *   <AnimationStyle Class="AnimationStyle" Animation="[libraryID]" StartFrame="0" EndFrame="0" Loop="false" Stop="false" />
 * @class AnimationStyle
 * @extends Style
 */
@engineComponent(ComponentTypes.Style)
export class AnimationStyle extends Style {
    // store only name of animation in style
    // element will create new instnce of animation not style
    animation: string;

    // settings for animation
    startFrame: number;
    endFrame: number;
    speed: number;
    loop: boolean;
    stop: boolean;
    alpha: number;
    tint: number;
    blendMode: number;
    reverse: boolean;

    // for InsideAnimationElement
    node: Element;

    constructor() {
        super();

        // set default values
        this.animation = "";
        this.startFrame = 0;
        this.speed = 1;
        this.loop = false;
        this.stop = false;
    }

    /**
     * Get attributes from xml and set up supported properties.
     * @method create
     * @param node is Element from xml
     * @return void
     */
    create(node: Element): void {
        super.create(node);

        /**
         * Store node for InsideAnimationElement
         *
         * todo Toto sa pouziva?
         * @type {Element}
         */
        this.node = node;

        if (node.hasAttribute(AnimationStyleAttributes.ANIMATION)) {
            this.animation = node.getAttribute(AnimationStyleAttributes.ANIMATION);
        }

        if (node.hasAttribute(AnimationStyleAttributes.START_FRAME)) {
            this.startFrame = parseInt(node.getAttribute(AnimationStyleAttributes.START_FRAME));
        }

        if (node.hasAttribute(AnimationStyleAttributes.END_FRAME)) {
            this.endFrame = parseInt(node.getAttribute(AnimationStyleAttributes.END_FRAME));
        }

        if (node.hasAttribute(AnimationStyleAttributes.LOOP)) {
            this.loop = StringUtils.parseBoolean(node.getAttribute(AnimationStyleAttributes.LOOP));
        }

        if (node.hasAttribute(AnimationStyleAttributes.STOP)) {
            this.stop = StringUtils.parseBoolean(node.getAttribute(AnimationStyleAttributes.STOP));
        }

        if (node.hasAttribute(AnimationStyleAttributes.SPEED)) {
            this.speed = parseFloat(node.getAttribute(AnimationStyleAttributes.SPEED));
        }

        if (node.hasAttribute(AnimationStyleAttributes.ALPHA)) {
            this.alpha = parseFloat(node.getAttribute(AnimationStyleAttributes.ALPHA));
        }

        if (node.hasAttribute(AnimationStyleAttributes.TINT)) {
            this.tint = parseInt(node.getAttribute(AnimationStyleAttributes.TINT), 16);
        }

        if (node.hasAttribute(AnimationStyleAttributes.BLEND_MODE)) {
            this.blendMode = CustomUtils.getBlendMode(parseInt(node.getAttribute(AnimationStyleAttributes.BLEND_MODE)));
        }
        if (node.hasAttribute(AnimationStyleAttributes.REVERSE)) {
            this.reverse = StringUtils.parseBoolean(node.getAttribute(AnimationStyleAttributes.REVERSE));
        }
    }
}

export const AnimationStyleAttributes = {
    /*
     * Animation is library ID from javascript libs.
     * @property Animation
     * @type string
     * @default null
     */
    ANIMATION: "Animation",
    /*
     * Start frame is number of frame when animation start on timeline.
     * @property StartFrame
     * @type number
     * @default 0
     */
    START_FRAME: "StartFrame",
    /*
     * End frame is number of frame when animation ends on timeline.
     * Use only if end frame is smaller then last frame on timeline.
     * @property EndFrame
     * @type number
     * @default null
     */
    END_FRAME: "EndFrame",
    /*
     * Indicates whenever this MovieClip should loop when it reaches the end of its timeline.
     * @property Loop
     * @type boolean
     * @default false
     */
    LOOP: "Loop",
    /*
     * Indicates whether this MovieClip shoud play only single frame animation.
     * @property Stop
     * @type boolean
     * @default false
     */
    STOP: "Stop",
    /*
     * Speed of animation. Less than one will slow down animation. Calc with game FPS.
     * @property Speed
     * @type number
     * @default 1
     */
    SPEED: "Speed",
    /*
     * Alpha (transparency) for this display object. 0 is fully transparent, 1 is fully opaque.
     * @property Alpha
     * @type Number
     * @default 1
     */
    ALPHA: "Alpha",
    /*
     * Tint of animation. Hex color which colorize movie clip.
     * @property Tint
     * @type string
     * @default null
     */
    TINT: "Tint",
    /*
     * Blend mode for animation.
     * Bleding modes:
     *   0 = NORMAL;
     *   1 = ADD;
     *   2 = MULTIPLY;
     *   3 = SCREEN;
     *   4 = OVERLAY;
     *   5 = DARKEN;
     *   6 = LIGHTEN;
     *   7 = COLOR_DODGE;
     *   8 = COLOR_BURN;
     *   9 = HARD_LIGHT;
     *   10 = SOFT_LIGHT;
     *   11 = DIFFERENCE;
     *   12 = EXCLUSION;
     *   13 = HUE;
     *   14 = SATURATION;
     *   15 = COLOR;
     *   16 = LUMINOSITY;
     * @property BlendMode
     * @type number
     * @default null
     */
    BLEND_MODE: "BlendMode",
    /*
     * Indicates if animation should animate reverse.
     * @property Reverse
     * @type boolean
     * @default false
     */
    REVERSE: "Reverse",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/Components/Elements/Styles/AnimationStyle.ts
 **/